module.exports = __webpack_public_path__ + "9cbf33ad5d4e8f40c6c8b0f045a5b0e5.fbx";